var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { CpslQrCode, CpslSpinner, CpslText } from '@usecapsule/react-components';
import styled from 'styled-components';
import { QRContainer } from '../common.js';
import { useCapsuleStore, useModalStore } from '../../stores/index.js';
import { ModalStep } from '../../utils/steps.js';
const CenteredContainer = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 20px;
`;
const FarcasterOAuthStep = () => {
    const [connectUri, setConnectUri] = useState('');
    const setStep = useModalStore(state => state.setStep);
    const setWebAuthURLForCreate = useModalStore(state => state.setWebAuthURLForCreate);
    const setWebAuthURLForLogin = useModalStore(state => state.setWebAuthURLForLogin);
    const capsule = useCapsuleStore(state => state.capsule);
    const setFlow = useModalStore(state => state.setFlow);
    useEffect(() => {
        const initializeFarcaster = () => __awaiter(void 0, void 0, void 0, function* () {
            const connectUri = yield capsule.getFarcasterConnectURL();
            setConnectUri(connectUri);
        });
        initializeFarcaster();
    }, []);
    useEffect(() => {
        if (connectUri) {
            const pollStatus = () => __awaiter(void 0, void 0, void 0, function* () {
                const { userExists, username } = yield capsule.waitForFarcasterStatus();
                setStep(ModalStep.AWAITING_OAUTH);
                if (userExists) {
                    const webAuthUrlForLogin = yield capsule.initiateUserLogin(username, false, 'farcaster');
                    setFlow('login');
                    setWebAuthURLForLogin(webAuthUrlForLogin);
                    setStep(ModalStep.BIOMETRIC_LOGIN);
                }
                else {
                    const webAuthURLForCreate = yield capsule.getSetUpBiometricsURL(false, 'farcaster');
                    setFlow('signUp');
                    setWebAuthURLForCreate(webAuthURLForCreate);
                    setStep(ModalStep.BIOMETRIC_CREATION);
                }
            });
            pollStatus();
            return () => {
                setConnectUri('');
            };
        }
    }, [connectUri]);
    return (_jsxs(CenteredContainer, { children: [_jsx(CpslText, { variant: "bodyL", weight: "bold", children: "Sign in using Farcaster" }), _jsx(CpslText, { children: "Scan the QR code with your phone's camera to proceed." }), _jsx(QRContainer, { children: !connectUri ? _jsx(CpslSpinner, {}) : _jsx(CpslQrCode, { url: connectUri }) })] }));
};
export default FarcasterOAuthStep;
